export default "__VITE_ASSET__Dvk7tbUQ__"